export type Environment = 'local' | 'dev' | 'stage' | 'prod';

const HOST_ENV_MAP: Record<string, Environment> = {
    'devsearch.kemet.com': 'dev',
    'stage.yageogroup.com': 'stage',
};

function isEnvironment(x: unknown): x is Environment {
    return x === 'local' || x === 'dev' || x === 'stage' || x === 'prod';
}

export function getEnvironment(): Environment {
    // Check for environment variable first, this should be our only source of truth, however
    // we don't pass REACT_APP_MODE to builds and we remove .env files from docker builds, so
    // this is used only for local development (FIXME)
    const fromEnv = (process.env.REACT_APP_MODE ?? '').toLowerCase();
    if (isEnvironment(fromEnv)) {
        return fromEnv as Environment;
    }

    // Workarounds because we don't pass REACT_APP_MODE to builds
    if (typeof window !== 'undefined' && window?.location?.hostname) {
        const mapped = HOST_ENV_MAP[window.location.hostname];
        if (mapped) {
            return mapped;
        }
        if (
            window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1' ||
            window.location.hostname.endsWith('.local')
        ) {
            return 'local';
        }
    }

    return 'prod';
}
